var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4949_19944)","key":0},React.createElement("path",{"d":"M32 16.7305C32 7.89391 24.8366 0.730469 16 0.730469C7.16344 0.730469 0 7.89391 0 16.7305C0 24.7164 5.85094 31.3358 13.5 32.5361V21.3555H9.4375V16.7305H13.5V13.2055C13.5 9.19547 15.8888 6.98047 19.5434 6.98047C21.2934 6.98047 23.125 7.29297 23.125 7.29297V11.2305H21.1075C19.12 11.2305 18.5 12.4639 18.5 13.7305V16.7305H22.9375L22.2281 21.3555H18.5V32.5361C26.1491 31.3358 32 24.7164 32 16.7305Z","fill":"#28293D"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4949_19944"},React.createElement("rect",{"width":"32","height":"32","fill":"white","transform":"translate(0 0.730469)"})))]);
}

Facebook.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
